import { render } from "./CardPermissionList.vue?vue&type=template&id=be106e22"
import script from "./CardPermissionList.vue?vue&type=script&lang=js"
export * from "./CardPermissionList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\TAfolabi\\Documents\\Projects\\legacy\\partner\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__